import React from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    NumberField,
    EditButton,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    SelectInput,
    BooleanInput,
    NumberInput,
    FileInput,
    FileField,
    required,
    Toolbar,
    SaveButton,
    DeleteButton,
} from "react-admin";

const categoryChoices = [
    { id: "report", name: "Внешний отчет" },
    { id: "template", name: "Шаблон Excel" },
];

const DownloadFileEditToolbar = () => (
    <Toolbar>
        <SaveButton />
        <DeleteButton
            mutationMode="pessimistic"
            confirmTitle="Удалить файл?"
            confirmContent="Вы действительно хотите удалить эту запись? Файл также будет удален с сервера."
        />
    </Toolbar>
);

export const DownloadFileList = () => (
    <List title="Загрузки" perPage={25}>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
            <NumberField source="id" label="ID" />
            <TextField source="title" label="Имя файла" />
            <TextField source="category" label="Категория" />
            <TextField source="system_name" label="Система / конфигурация" />
            <TextField source="version" label="Версия" />
            <BooleanField source="is_active" label="Активен" />
            <NumberField source="sort_order" label="Порядок" />
            <EditButton />
        </Datagrid>
    </List>
);

export const DownloadFileCreate = () => (
    <Create title="Добавить файл">
        <SimpleForm>
            <TextInput
                source="title"
                label="Имя файла"
                fullWidth
                validate={required()}
            />

            <TextInput
                source="description"
                label="Описание"
                multiline
                minRows={3}
                fullWidth
            />

            <TextInput
                source="system_name"
                label="Система / конфигурация"
                fullWidth
            />

            <TextInput
                source="version"
                label="Версия"
            />

            <SelectInput
                source="category"
                label="Категория"
                choices={categoryChoices}
                validate={required()}
                fullWidth
            />

            <NumberInput
                source="sort_order"
                label="Порядок сортировки"
            />

            <BooleanInput
                source="is_active"
                label="Активен"
                defaultValue={true}
            />

            <FileInput
                source="file"
                label="Файл"
                accept=".erf,.xlsx,.xls,.zip,.pdf"
                validate={required()}
            >
                <FileField source="src" title="title" />
            </FileInput>
        </SimpleForm>
    </Create>
);

export const DownloadFileEdit = () => (
    <Edit title="Редактировать файл">
        <SimpleForm toolbar={<DownloadFileEditToolbar />}>
            <TextInput
                source="title"
                label="Имя файла"
                fullWidth
                validate={required()}
            />

            <TextInput
                source="description"
                label="Описание"
                multiline
                minRows={3}
                fullWidth
            />

            <TextInput
                source="system_name"
                label="Система / конфигурация"
                fullWidth
            />

            <TextInput
                source="version"
                label="Версия"
            />

            <SelectInput
                source="category"
                label="Категория"
                choices={categoryChoices}
                validate={required()}
                fullWidth
            />

            <NumberInput
                source="sort_order"
                label="Порядок сортировки"
            />

            <BooleanInput
                source="is_active"
                label="Активен"
            />

            <FileInput
                source="file"
                label="Новый файл"
                accept=".erf,.xlsx,.xls,.zip,.pdf"
            >
                <FileField source="src" title="title" />
            </FileInput>
        </SimpleForm>
    </Edit>
);